var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoIgnoreWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 599,
    viewBox: "0 0 600 599",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1225_33)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 110.18,
    y1: 488.18,
    x2: 474.18,
    y2: 124.18,
    stroke: "white",
    strokeWidth: 90
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 299,
    r: 260,
    stroke: "white",
    strokeWidth: 80
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1225_33"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 599,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoIgnoreWhite);
export default __webpack_public_path__ + "static/media/ico_ignore_white.c056de36d405d92e050360333c9f12fb.svg";
export { ForwardRef as ReactComponent };